/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Delete_Dialog_TitleInputs */

const en_ui_delete_dialog_title = /** @type {(inputs: Ui_Delete_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete All Data`)
};

const de_ui_delete_dialog_title = /** @type {(inputs: Ui_Delete_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Daten löschen`)
};

/**
* | output |
* | --- |
* | "Delete All Data" |
*
* @param {Ui_Delete_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_delete_dialog_title = /** @type {((inputs?: Ui_Delete_Dialog_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Delete_Dialog_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_delete_dialog_title(inputs)
	return de_ui_delete_dialog_title(inputs)
});